import classNames from 'classnames'
import type { CSSProperties } from 'react'
import React from 'react'
import styles from './ProgressIndicator.module.scss'
import { ProgressIndicatorSize, ProgressIndicatorStyle } from './types'
import type { ProgressIndicatorProps } from './types'

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  className,
  animated = false,
  progress,
  rtl = false,
  size = ProgressIndicatorSize.large,
  style = ProgressIndicatorStyle.positive,
}) => {
  const progressCssVariable = {
    '--pintxo-progress-indicator-value': `${progress}%`,
  } as CSSProperties

  return (
    <progress
      className={classNames(styles['pintxo-progress-indicator'], className)}
      value={progress}
      max={100}
      data-size={size}
      data-style={style}
      data-rtl={rtl}
      data-animated={animated}
      style={progressCssVariable}
    />
  )
}

export default ProgressIndicator
